import React from 'react';
import { Navigation } from '../components/Navigation';
import { ShopSection } from '../components/ShopSection';
import { Footer } from '../components/Footer';

const ShopPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <ShopSection />
      </div>
      <Footer />
    </div>
  );
};

export default ShopPage;
